import React from "react";
import Lifecycle from "./Lifecycle";
import KeyValTable from "../Common/KeyValTable";
const Trip = ({ data = {} }) => {
  return (
    <div>
      <h2>Trip</h2>
      <KeyValTable data={data.trip} />
      <Lifecycle data={data.lifecycle || {}} />
    </div>
  );
};
export default Trip;
